import { render, staticRenderFns } from "./NewsPopup.vue?vue&type=template&id=41dcb605"
import script from "./NewsPopup.vue?vue&type=script&lang=js"
export * from "./NewsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports